import { Injectable } from '@angular/core';
import { environment } from 'projects/main/src/environments/environment';

@Injectable({providedIn: 'root'})
export class BaseService {

  apiUrl = environment.apiUrl;
  projects = environment.projectsApi;
  projectRoles = environment.projectroles;
  models = environment.modelsApi;
  revisions = environment.revisionsApi;
  wexbim = environment.revisionsApi;
  apiUrlRevisions = environment.apiUrlRevisions;
  account = environment.account;
  identity = environment.identityApi;
  identityAccount = environment.identityAccount;
  identityAdmin = environment.identityAdmin;
  userprofiles = environment.userProfile;
  userPermissions = environment.userPermissions;
  permissions = environment.permissions;
  genericDocuments = environment.genericDocuments;
  documents = environment.documents;
  valueConfPage = environment.valueConfPage;
  valueConfAttribute = environment.valueConfAttribute;
  attributeValue = environment.attributeValue;
  statusColor = environment.statusColor;
  databaseMigrations = environment.databaseMigrations;  
  groupRoles = environment.groupRoles;
  platformGroupRoles = environment.platformGroupRoles;
  projectGroupRoles = environment.projectGroupRoles;
  groupRolePermissions = environment.groupRolePermissions;
  projectGroupRolePermissions = environment.projectGroupRolePermissions
  localLegacySquirrelCommonApi = environment.localLegacySquirrelCommonApi;
  localLegacySquirrelV3 = environment.localLegacySquirrelV3;
  devLegacySquirrelCommonApi = environment.devLegacySquirrelCommonApi;
  devLegacySquirrelV3 = environment.devLegacySquirrelV3;
  squirreltest1LegacySquirrelCommonApi = environment.squirreltest1LegacySquirrelCommonApi;
  squirreltest1LegacySquirrelV3 = environment.squirreltest1LegacySquirrelV3;
  sq3devLegacySquirrelCommonApi = environment.sq3devLegacySquirrelCommonApi;
  sq3devLegacySquirrelV3 = environment.sq3devLegacySquirrelV3;
  tenants = environment.tenants;
  tenantProjects = environment.tenantProjects;
  tenantUsers = environment.tenantUsers;
  tenantProjectGroupRoles = environment.tenantProjectGroupRoles;
  tenantGroupRolePermissions = environment.tenantGroupRolePermissions;
  tenantProjectRoles = environment.tenantProjectRoles;
  tenantProjectGroupRolePermissions = environment.tenantProjectGroupRolePermissions;
  tenantplatformGroupRoles = environment.tenantplatformGroupRoles;
  tenantpermissions = environment.tenantpermissions;
  tenantgrouproles = environment.tenantgrouproles;
  tenantapplicationtokens = environment.tenantapplicationtokens;
  tenantAudit = environment.tenantaudit;
  tenantfiles = environment.tenantfiles;

  projecturl = environment.projecturl;
  
  constructor() { }
}
